"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function Spinner({ centerPage = false, dataTestId, size = 'medium', }) {
    return ((0, jsx_runtime_1.jsx)("div", { "data-testid": dataTestId, className: `${centerPage ? 'spinner-center-shell' : 'spinner-default'}`, children: (0, jsx_runtime_1.jsx)("div", { className: `${centerPage ? 'spinner-center' : ''}`, children: (0, jsx_runtime_1.jsx)("div", { id: "spinner", className: `spinner-${size}` }) }) }));
}
exports.default = Spinner;
